import React, { useState, useEffect } from "react";
import axios from "axios";
import { APILINK } from "../../EndPoint";
import axiosInstance from "../../api/axiosInstance";
import ErrorHandler from "../../error-handler/ErrorHandler";
import { Container, Row, Col, Tooltip, OverlayTrigger } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { Spin, Empty, Pagination } from "antd";
import DataTable from "react-data-table-component";
import DeleteModal from "../layout/deleteModal";


const axiosApiInstance = axios.create();
const Documents = (props) => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [count, setCount] = useState("1");
    const [current, setCurrent] = useState("1");
    const [showDeleteModal, setShowDelete] = useState(false)
    const [documentID, setID] = useState("");
    const [columns, setCoulmns] = useState([
        {
            name: `${t("jobsTable.arabic")}`,
            selector: row=>row.title_ar,
            sortable: true,
            right: true,
        },
        {
            name: `${t("jobsTable.english")}`,
            selector: row=>row.title_en,
            sortable: true,
            right: true,
        },
        {
            name: `${t("reports.category")}`,
            selector: row=>row.categories.map(category=>category.title_en + " , "),
            sortable: true,
            right: true,
        },
        {
            name: `${t("requestType")}`,
            selector: row=>row.request_type,
            sortable: true,
            right: true,
        },
        {
            name: `${t("unverifiedTable.actions")}`,
            button: true,
            cell: (row) => (
                <div className="table-data-feature">

                    <OverlayTrigger
                        key="1"
                        placement={"top"}
                        overlay={<Tooltip id={`tooltip-${"top"}`}>Update Document</Tooltip>}
                    >
                        <i
                            id={row.id}
                            onClick={e => updateDocument(row.id)}
                            className="fas fa-pen pr-2"
                        ></i>
                    </OverlayTrigger>
                    <OverlayTrigger
                        key="2"
                        placement={"top"}
                        overlay={<Tooltip id={`tooltip-${"top"}`}>Delete Document</Tooltip>}
                    >
                        <i
                            id={row.id}
                            onClick={id => showDelete(row.id)}
                            className="fas fa-trash pr-2"
                        ></i>
                    </OverlayTrigger>
                </div>
            ),
        },
    ]);

    const getDocuments = async () => {
        let result = await axiosApiInstance.get(
            APILINK + `/document`,
            {
                headers: {
                    "Accept-Language": localStorage.getItem("lang"),
                },
            }
        );
        console.log(result.data.data);
        if (result) {
            setData(result.data.data);
            setLoading(false);
        }
    };

    const updateDocument = (id) => {
        props.history.push(`/edit_document/${id}`)
    }
    const showDelete = (id) => {
        setShowDelete(true)
        console.log(id)
        setID(id)
    }


    const closeDelete = (e) => {
        setShowDelete(false);
    };


    const onChange = async (page) => {
        console.log(page);
        setCurrent(page);

        let result = await axiosInstance.get(`/document?page=${page}`);
        setData(result.data.data);
        setCount(result.data.count);
    };


    useEffect(() => {
        setLoading(true);
        getDocuments();
    }, []);
    const addDocument = () => {
        props.history.push("/CreateDocument")
    }

    return (
        <Container
            style={{
                textAlign: localStorage.getItem("lang") == "ar" ? "right" : "left",
            }}
            className="viewSuper align-left usersForm"
        >
            <Row className="mb-4 ">
                <Col lg={12}>
                    <h5>Bank Documents</h5>
                </Col>
            </Row>
            <Row>
                <Col className="align-right mb-4" lg={12}>
                    <button onClick={addDocument} className="defaultButton">{t("createDocument")}</button>

                </Col>
            </Row>

            {data.length !== 0 && loading == false ? (
                <Row>
                    <DataTable columns={columns} data={data} />
                </Row>

            ) : data.length === 0 && loading == false ? (
                <Empty />
            ) : (
                <Spin tip="...loading" />
            )}
            <Row className="p-4">
                {data.length !== 0 ? (
                    <Pagination
                        onChange={onChange}
                        defaultCurrent={current}
                        total={count}
                        current={current}
                    />
                ) : null}
            </Row>
            <DeleteModal show={showDeleteModal} hide={() => setShowDelete(false)} cancel={closeDelete} url={`/document/${documentID}`} modalHeader="Are you sure you want to delete this document?" />

            <ToastContainer position="bottom-right" />
        </Container>
    );
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

export default connect(
    mapStateToProps,
    null
)(ErrorHandler(Documents, axiosApiInstance));
